/**
 *  Copyright (c) 2022-present TVM Engineering Authors.
 *
 */

import types from '../actions/types';
import { ROLES } from '../config';

const INITIAL_STATE = {
	profile: {},
	message: '',
	error: '',
	users: [],
	selectedUser: '',
	ROLES
};

export default function userReducer(state = INITIAL_STATE, action) {
	switch (action.type) {
		case types.FETCH_USER:
			return { ...state, profile: action.payload };
		case types.FETCH_ALL_USERS:
			return { ...state, users: action.payload };
		case types.FETCH_CREATE_USER:
			return { ...state, users: action.payload };
		default:
			return state;
	}
}

// Selectors
export const getUser = (state) => state.user.profile;
export const getSelectedUser = (state) => state.user.selectedUser;
export const getUsers = (state) => state.user.users;
export const getRoles = (state) => state.user.ROLES;

